var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.question.content)?_c('div',{staticClass:"f-content"},[_c('span',{staticClass:"f-section-text"},[_vm._v(_vm._s(_vm.question.content))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }